import { createContext, useContext } from 'react'
import type { ReactNode } from 'react'

export type LandingFlags = {
  brokerPortalEnabled: boolean
}

const FlagsContext = createContext<LandingFlags>({
  brokerPortalEnabled: false,
})

type FlagsProviderProps = {
  flags: LandingFlags
  children: ReactNode
}

export const FlagsProvider = ({ flags, children }: FlagsProviderProps) => (
  <FlagsContext.Provider value={flags}>{children}</FlagsContext.Provider>
)

export const useFlags = () => useContext(FlagsContext)
